import { List } from "components/index";
import { Badge } from "ui/components/badge";
import { getUserFields } from "components/user/config";
import { UserCell } from "components/cell/user/cell"
import { EmployeeCell } from "components/cell/employee/cell";
import OrganizationEmployeeFilters from "./filter";
import CreateListItemButton from "@/components/list/create-button";

export default function OrganizationEmployees() {
  const fields = [
    "id",
    ...getUserFields(),
    getUserFields("reports_to"),
    "title.id",
    "job_title.name",
    "function.name",
    "employee_id",
    "email",
    "allocable",
  ];

  const columns = [
    {
      header: "Employee ID",
      accessorKey: "employee_id",
      cell: ({ getValue }) => getValue(),
      sortable: true,
    },
    {
      header: "Name",
      accessorKey: "first_name",
      cell: UserCell,
      sortable: true,
    },
    {
      header: "Department",
      accessorKey: "department.name",
      cell: ({ getValue }) => {
        if (!getValue()) return null;
        return <Badge variant="outline">{getValue()}</Badge>;
      },
    },
    {
      header: "Email",
      accessorKey: "email",
      cell: ({ getValue }) => getValue(),
    },
    {
      header: "Reports to",
      accessorKey: "reports_to",
      cell: EmployeeCell,
    },
    {
      header: "Allocable",
      accessorKey: "allocable",
      cell: ({ getValue }) => {
        return getValue() ? "Yes" : "No";
      },
    },
  ];

  const filters = {
    user: {
      status: {  _eq: "active" },
    },
    type: { _neq: "client" },
  };

  return (
    <div key={JSON.stringify(filters)} className="flex-1">
      <List
        attrs={fields}
        endPoint="employees"
        meta={{ fields }}
        title={"Employees"}
        columns={columns}
        sortBy={"employee_id"}
        storageKey={"organization-employees"}
        renderFilters={OrganizationEmployeeFilters}
        filters={filters}
        href={(item) => `/organization/employees/${item.id}`}
      />
      <CreateListItemButton rule="create:*" collection="employees">
        Employee
      </CreateListItemButton>
    </div>
  );
}
